/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {AudioVideoDownloadJobInfo} from "../model/audio-video-download-job-info";
import {DeleteJobRequest} from "../model/delete-job-request";
import {DeleteTemporaryFileJobInfo} from "../model/delete-temporary-file-job-info";
import {ExportProcessInfo} from "../model/export-process-info";
import {ListData} from "../model/list-data";
import {RetryJobRequest} from "../model/retry-job-request";
import {SchedulerEventLogEntry} from "../model/scheduler-event-log-entry";
import {SwitchCastVideoProcessingJobInfo} from "../model/switch-cast-video-processing-job-info";
import {SwitchCastVideoUploadJobInfo} from "../model/switch-cast-video-upload-job-info";
import {SynchronizationJobInfo} from "../model/synchronization-job-info";

@Injectable({
    providedIn: "root",
})
export class SimJobsService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public deleteAudioVideoDownloadJob(request: DeleteJobRequest) {
        return super.post<boolean>(`/api/Jobs/DeleteAudioVideoDownloadJob`, request);
    }

    public deleteExportProcessInfo(request: DeleteJobRequest) {
        return super.post<boolean>(`/api/Jobs/DeleteExportProcessInfo`, request);
    }

    public getAudioVideoDownloadJobs(sortColumn: string, sortAscending: boolean, page: number, pageSize: number) {
        return super.get<ListData<AudioVideoDownloadJobInfo>>(`/api/Jobs/GetAudioVideoDownloadJobs`, {sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getDeleteTemporaryFilesJobs(sortColumn: string, sortAscending: boolean, page: number, pageSize: number) {
        return super.get<ListData<DeleteTemporaryFileJobInfo>>(`/api/Jobs/GetDeleteTemporaryFilesJobs`, {sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getExportProcessInfos(sortColumn: string, sortAscending: boolean, page: number, pageSize: number) {
        return super.get<ListData<ExportProcessInfo>>(`/api/Jobs/GetExportProcessInfos`, {sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getJobLogs(jobId: string) {
        return super.get<SchedulerEventLogEntry[]>(`/api/Jobs/GetJobLogs`, {jobId: jobId});
    }

    public getSwitchCastVideoProcessingJobs(sortColumn: string, sortAscending: boolean, page: number, pageSize: number) {
        return super.get<ListData<SwitchCastVideoProcessingJobInfo>>(`/api/Jobs/GetSwitchCastVideoProcessingJobs`, {sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getSwitchCastVideoUploadJobs(sortColumn: string, sortAscending: boolean, page: number, pageSize: number) {
        return super.get<ListData<SwitchCastVideoUploadJobInfo>>(`/api/Jobs/GetSwitchCastVideoUploadJobs`, {sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getSynchronizationJobs(sortColumn: string, sortAscending: boolean, page: number, pageSize: number) {
        return super.get<ListData<SynchronizationJobInfo>>(`/api/Jobs/GetSynchronizationJobs`, {sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public retryAudioVideoDownloadJob(request: RetryJobRequest) {
        return super.post<boolean>(`/api/Jobs/RetryAudioVideoDownloadJob`, request);
    }

    public retryDeleteTemporaryFilesJob(request: RetryJobRequest) {
        return super.post<boolean>(`/api/Jobs/RetryDeleteTemporaryFilesJob`, request);
    }

    public retryExportProcessInfo(request: RetryJobRequest) {
        return super.post<boolean>(`/api/Jobs/RetryExportProcessInfo`, request);
    }

    public retrySwitchCastVideoProcessingJobs(request: RetryJobRequest) {
        return super.post<boolean>(`/api/Jobs/RetrySwitchCastVideoProcessingJobs`, request);
    }

    public retrySwitchCastVideoUploadJobs(request: RetryJobRequest) {
        return super.post<boolean>(`/api/Jobs/RetrySwitchCastVideoUploadJobs`, request);
    }

    public retrySynchronizationFilesJob(request: RetryJobRequest) {
        return super.post<boolean>(`/api/Jobs/RetrySynchronizationFilesJob`, request);
    }
}